<template>
	<div>
    <b-modal hide-footer
    id="modalPrevent2"
    ref="alertmodel"
    title="Alert... !!!"
    ><div class="d-block text-center">
        <h3>Your stack has been freed</h3>
      </div>
      <b-button class="mt-3" variant="outline-danger" block @click="$refs.alertmodel.hide()">Close Me</b-button>
  </b-modal>
  <b-modal hide-footer
    id="modalPrevent2"
    ref="myModalRef2"
    title="Employee List"
    @ok="handleOk2"
    >
    <b-table class="hide-top-border" :items="employeeelist" :fields="fieldemployeeslist"  show-empty/>
  </b-modal>  
  <b-modal  hide-footer
  id="modalPrevent1"
  ref="myModalRef1"
  title="Enter Squad Name"
  @shown="clearName1"
  >
  <form @submit.stop.prevent="handleSubmit1">
    <b-form-input type="text" v-model="newsquadname" placeholder="Squad Name" style="margin-bottom:20px;"/>
    <b-button align="center" variant="success" class="w-25 float-right" @click="addsquadtodb">
      Add
    </b-button>
  </form>
</b-modal>
<b-container>
  <b-row class="box-container">
      <section class="header-card">
        <h4 class="card-title">Teams <b-button v-if="role=='admin'" size="sm" variant="success" class="w-10 float-right" @click="addsquad">Create New</b-button></h4>
        <p class="card-category">Here listed the stacks </p>
      </section>
      <b-table class="hide-top-border app-normal-table" :items="itemsteams" :fields="fieldsteam" show-empty >
        <template slot="views" slot-scope="row">
          <b-button variant="info" size="sm" @click="myRowClickHandler(row.item)" class="mr-1">
            View Members
          </b-button>
        </template>
        
        <template  slot="actions" slot-scope="row">
          <b-button v-if="role=='admin'" variant="success" size="sm" @click="myRowClickHandleraddmembers(row.item)" class="mr-1">
            Add Members
          </b-button>
        </template>
      </b-table>
      <b-pagination align="right"   size="sm" :total-rows="totalsquadentries" v-model="currentPage" :per-page="5" />
  </b-row>
</b-container>
    </div>
  </template>
  <script>
    import http from "../http-common"
    import {  mapGetters, mapActions } from 'vuex'
    export default {
     name:'Teams',
     data() {
      return {
        itemsteams: [],
        fieldsteam: ['squadname','views','actions'],
        newsquadname:'',
        totalsquadentries: 1,
        currentPage:1,
        employeeelist:[],
        fieldemployeeslist:['employee'],
        role:'',
        send_message: null,
        connected: false,
        stompvalue:''
      }
    },
    methods: {
      ...mapActions([
       'commitactivetab_actions',
       'send_actions',
       'connect_actions',
       'disconnect_actions',
       'tickleConnection_actions'
      ]),
      send_actions_click(){
        var msg={
          message:'hai',
          url:'/app/test'
        }
        this.send_actions(msg)
      },
      funtest(){
        this.disconnect_actions()
      },
      ...mapActions([
              'commitactivetab'
      ]),
      setactivetab: function(value) {
            this.commitactivetab(value)
      },
      clearName1() {
        this.newsquadname=''
      },
      handleOk2() {
        this.$refs.myModalRef2.hide()
      },
      handleSubmit1() {
        this.clearName1()
        this.$nextTick(() => {
          this.$refs.myModalRef1.hide()
        })
      },
      myRowClickHandler(record) {
        this.getEmployeesBySquad(record['id'])
        this.$refs.myModalRef2.show()
      },
      myRowClickHandleraddmembers(record) {
        this.getEmployeesBySquad(record['id'])
        this.$refs.myModalRef3.show()
      },
      async getEmployeesBySquad(id){
        await http
        .get("/getEmployeeById",{ params:{sqid:id}})
        .then(response => {
          this.employeeelist = response.data
        })
        .catch(e => {
          console.log(e)
        })
      },
      async retrieveSquads(page) {
        await http
        .get("/squads/"+page)
        .then(response => {
          this.itemsteams = response.data
        })
        .catch(e => {
          console.log(e)
        })
      },
      addsquad(){
       this.$refs.myModalRef1.show()
     },
     addsquadtodb(){
       http
       .post("/addsquad", this.newsquadname)
       .catch(e => {
         console.log(e)
       })
       this.$refs.myModalRef1.hide()
       this.send_actions_click()
     },
     async setactivepagesquad(pageno){
       this.retrieveSquads(pageno-1)
       await this.gettotalsquadentries()
     },
     async gettotalsquadentries(){
       await http
       .get("/squadscount")
       .then(response => {
        this.totalsquadentries=response.data
      })
       .catch(e => {
         console.log(e)
       })
     }
   },
   computed: {
      ...mapGetters([
      'getreceived_messages_store'
      ]),

    },
    watch: {
      getreceived_messages_store:async function (val){
        if(val.content_type=="stack_changes"){
          this.retrieveSquads(0)
          this.gettotalsquadentries()
        }
      },
    currentPage: function (val) {
      this.setactivepagesquad(val)
    }
  },
  created() {
    this.setactivetab(3)
    this.retrieveSquads(0)
    this.gettotalsquadentries()
    this.role=this.$session.get("role")
  }
}
</script>
<style >
</style>